import { AdditionalInfo, AdditionalInfoSchema } from "#app/components/get-a-quote/additional-information.tsx";
import { AddressInfo, AddressInfoSchema } from "#app/components/get-a-quote/address-info.tsx";
import { ContactInfo, ContactInfoSchema } from "#app/components/get-a-quote/contact-info.tsx";
import { PersonalInfo, PersonalInfoSchema } from "#app/components/get-a-quote/personal-info.tsx";
import { z } from "zod";

export type FormStep = "personal-information" | "contact-information" | "address-information" | "additional-information" | "completed";

export type FormStepConfig = {
    name: string;
    component: React.ComponentType<any> | null; // Or a more specific type
    route: string;
    schema: z.ZodTypeAny;
};

export const formSteps: Record<FormStep, FormStepConfig> = {
    'personal-information': { name: "Name", component: PersonalInfo, route: "personal-information", schema: PersonalInfoSchema },
    "contact-information": { name: "Contact", component: ContactInfo, route: "contact-information", schema: ContactInfoSchema },
    "address-information": { name: "Address", component: AddressInfo, route: "address-information", schema: AddressInfoSchema },
    "additional-information": { name: "Service", component: AdditionalInfo, route: "additional-information", schema: AdditionalInfoSchema },
    completed: { name: "Completed", component: null, route: "completed", schema: z.object({}) },
};

export const formStepOrder: FormStep[] = [
    "personal-information",
    "contact-information",
    "address-information",
    "additional-information",
    "completed",
];